"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.consts = exports.interceptors = exports.clients = void 0;

var _AuthInterceptor = require("./AuthInterceptor");

var _ImageManagementClient = require("./ImageManagementClient");

var _BaseDataServerClient = require("./BaseDataServerClient");

var _SecurityClient = require("./SecurityClient");

var _consts = _interopRequireWildcard(require("./consts"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var clients = {
  ImageManagementClient: _ImageManagementClient.ImageManagementClient,
  SecurityClient: _SecurityClient.SecurityClient,
  BaseClient: _BaseDataServerClient.BaseDataServerClient
};
exports.clients = clients;
var interceptors = {
  AuthInterceptor: _AuthInterceptor.AuthInterceptor
};
exports.interceptors = interceptors;
var consts = _consts;
exports.consts = consts;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/core/index.js
// module id = 84
// module chunks = 0